<template>
  <v-icon class="ml-0" :color="color" :left="left" :right="right" :disabled="disabledComputed" @click="onClick">
    {{ iconName }}
  </v-icon>
</template>

<script>
export default {
  name: 'Icon',

  props: {
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconName: {
      type: String,
      required: false,
      default: '',
    },
    isCheckRole: {
      // 編集、参照ロールチェックを実施するか判定
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    disabledComputed() {
      return this.disabled || !this.canEdit
    },
    canEdit() {
      if (this.isCheckRole) {
        return this.$store.getters.hasEditRole
      } else {
        return true
      }
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
